module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1@2-2eee2753ac53ac7d66733668b5a61d1e.webp";